import ABSService from "./absService";

class UserService extends ABSService {
    constructor() {
        super("user");
    }

    getList = async (query) => this.requestHelper.get(this.URL, query, { showMask: false });

    getById = async (id) => this.requestHelper.get(`${this.URL}/${id}`, null, { showMask: false });

    update = async (data) => this.requestHelper.post(this.URL, data, { showMask: false });

    updateRoles = async (userName, roles) => this.requestHelper.post(`${this.URL}/roles`, { userName, roles }, { showMask: false });
}

export default UserService;
